import BabyUITheme from 'baby-ui/lib/BabyUITheme'
import babyUIThemeToMuiThemeAdapter from 'baby-ui/utils/babyUIThemeToMuiThemeAdapter'
import { createTheme } from '@material-ui/core/styles'

export default function generateTheme(theme: BabyUITheme) {
  const translatedTheme = babyUIThemeToMuiThemeAdapter(theme)
  return createTheme(translatedTheme)
}
